import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import PiggyGiftCard from '../../../smoothr-web-app-core/models/PiggyGiftCard';
import { TranslateService } from '@ngx-translate/core';

export interface AddGiftCardModalResult {
	giftCard: PiggyGiftCard;
}

@Component({
	standalone: false,
	selector: 'app-add-gift-card-modal',
	templateUrl: './add-gift-card-modal.component.html',
	styleUrls: ['./add-gift-card-modal.component.scss'],
})
export class AddGiftCardModalComponent {
	loading = false;
	giftCard: PiggyGiftCard | null = null;
	giftCardCode = '';
	giftCardError = '';
	formattedGiftCardBalance = '';

	private repositoryService = inject(RepositoryService);
	private modalCtrl: ModalController = inject(ModalController);
	private translate = inject(TranslateService);

	constructor() {}

	get isValid(): boolean {
		return this.giftCard !== null && this.giftCard.balance > 0;
	}

	static async show(modalCtrl: ModalController): Promise<AddGiftCardModalResult> {
		const modal = await modalCtrl.create({
			component: AddGiftCardModalComponent,
			cssClass: 'payment-sheet-modal',
		});

		await modal.present();
		const { data } = await modal.onDidDismiss();
		return data;
	}

	async checkGiftCard() {
		if (!this.giftCardCode.trim()) {
			this.giftCardError = this.translate.instant('giftCard.errorEmpty');
			return;
		}

		this.loading = true;
		this.giftCardError = '';

		try {
			// Call RepositoryService to check giftCard balance
			// Assuming there's a method like: getGiftCardBalance(code: string, venue: Venue)
			this.giftCard = await this.repositoryService.getGiftCard(this.giftCardCode);
			console.log('GiftCard:', this.giftCard);
			this.formattedGiftCardBalance = this.repositoryService.currencyFormat.format(this.giftCard.balance);

			if (this.giftCard.balance <= 0) {
				this.giftCardError = this.translate.instant('giftCard.errorInsufficient', { balance: this.formattedGiftCardBalance });
			}
		} catch (error) {
			console.error('Error checking giftcard:', error);
			this.giftCardError = this.translate.instant('giftCard.errorNotFound');
			this.giftCard = null;
		} finally {
			this.loading = false;
		}
	}

	async confirmButton() {
		if (!this.isValid) {
			return;
		}

		await this.modalCtrl.dismiss({
			giftCard: this.giftCard,
		});
	}

	close() {
		this.modalCtrl.dismiss();
	}
}
